import { render } from "./EuroTokenFaucet.vue?vue&type=template&id=0b43f1d7"
import script from "./EuroTokenFaucet.vue?vue&type=script&lang=js"
export * from "./EuroTokenFaucet.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__